import { z } from "zod";
export const pushSubscribeSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string(),
        auth: z.string(),
    }),
});
export const pushUnsubscribeSchema = z.object({
    endpoint: z.string().url(),
});
export const pushDeviceSchema = z.object({
    id: z.string(),
    userAgent: z.string().nullable(),
    createdAt: z.coerce.date(),
    lastSeenAt: z.coerce.date(),
});
export const subscribeResponseSchema = z.object({
    success: z.boolean(),
});
export const unsubscribeResponseSchema = z.object({
    success: z.boolean(),
});
export const listDevicesResponseSchema = z.object({
    devices: z.array(pushDeviceSchema),
});
